__turbopack_context__.v({
  "className": "playfair_display_6d46805-module__AGNNTW__className",
  "variable": "playfair_display_6d46805-module__AGNNTW__variable",
});
